import React, { Component } from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from "@material-ui/core/TextField";
import API from "../../actions";
import Joi from "joi-browser";


class NewClinicUserForm extends Component {
    state = {
        data: {},
        genres: [],
        errors: {},
        alert: {
            open: false,
            message: ''
        }
    };

    schema = {
        nameFirst: Joi.string().required().label("Fornavn"),
        nameLast: Joi.string().required().label("Efternavn"),
        phone: Joi.string().required().regex(/^\+*\d{8,}$/).label("Telefon"),
        email: Joi.string().email().required().label("Email"),
        password: Joi.string().min(6).required().label("Adgangskode"),
        confirmPassword: Joi.string().min(6).required().valid(Joi.ref('password')).label("Bekræft kodeord"),
    };

    validateProperty = ({ name, value }) => {
        const obj = { [name]: value };
        let schema = { [name]: this.schema[name] };
        if (name === 'confirmPassword') {
            schema = { [name]: Joi.string().min(6).required().valid(this.state.data['password']).label("Bekræft kodeord") };
        }
        const result = Joi.validate(obj, schema);
        if (!result.error) return null;
        return result.error.details[0].message;
    };
    handleChange = ({ currentTarget: input }) => {
        const errors = { ...this.state.errors };
        const errorMessage = this.validateProperty(input);
        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];
        const data = { ...this.state.data };
        data[input.name] = input.value;
        this.setState({ data, errors });
    };

    validateForm = () => {
        const options = {
            abortEarly: false
        };

        const result = Joi.validate(this.state.data, this.schema, options);
        if (!result.error) return null;
        const errors = {};
        for (let item of result.error.details) errors[item.path[0]] = item.message;
        return errors;
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        this.setState({ errors: errors || {} });
        if (errors) {
            return;
        }
        const { data } = this.state;

        try {
            await API.addTherapist({
                username: data.email,
                email: data.email,
                phone: data.phone,
                password: data.password,
                nameFirst: data.nameFirst,
                nameLast: data.nameLast,
                trial: Date.now() + 1000 * 60 * 60 * 24 * 30 * 3
            });
            // reset data form
            this.setState({ data: {} });
            this.props.onClose();

            // alert
            alert('Brugeren er oprettet med succes.');

        } catch (err) {
            if (err === "username taken") alert("Brugernavnet er taget");
            else alert("Fejl: " + err);
        }
    };

    renderInput = (label, type = "text", name, autoFocus = false, maxlength = 0) => {
        const { data } = this.state;
        const { errors } = this.state;
        const inputProps = {};
        if (maxlength > 0) {
            inputProps['maxLength'] = maxlength;
        }

        return (
            <TextField
                margin="normal"
                required={true}
                fullWidth
                id={name}
                label={label}
                name={name}
                value={data[name] || ''}
                autoComplete={name}
                autoFocus={autoFocus}
                type={type}
                onChange={this.handleChange}
                error={errors[name] && true}
                inputProps={inputProps}
            // helperText={errors[name]}
            />
        );
    };

    render() {
        const { dialogOpen, onClose } = this.props;
        return (
            <div>
                <Dialog maxWidth="xs" open={dialogOpen} aria-labelledby="form-dialog-title">
                    <form method="post" className="form-movie" onSubmit={this.handleSubmit}>

                        <DialogTitle id="form-dialog-title">Opret bruger</DialogTitle>
                        <DialogContent>
                            {this.renderInput('Fornavn', 'text', 'nameFirst', true, 100)}
                            {this.renderInput('Efternavn', 'text', 'nameLast', false, 100)}
                            {this.renderInput('Telefon', 'text', 'phone', false, 20)}
                            {this.renderInput('Email', 'text', 'email', false, 100)}
                            {this.renderInput('Adgangskode', 'password', 'password', false, 100)}
                            {this.renderInput('Bekræft kodeord', 'password', 'confirmPassword', false, 100)}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onClose} color="primary">Luk</Button>
                            <Button type="submit" color="primary">Opret</Button>
                        </DialogActions>
                    </form>

                </Dialog>
            </div>
        );
    }
}

export default NewClinicUserForm;
